import { CustomerSpot } from "types/request";

export function spotTime(spot: CustomerSpot): string {
    return {
        AM: '8am - 12pm',
        PM: '12pm - 5pm',
        AT: '8am - 5pm',
    }[spot.attributes.window];
}